import { ResourceCreatePage } from '@/features/access/pages/resource/ResourceCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/resource/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_resources.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ResourceCreatePage,
})
